import campaignSagas from '../sagas/campaigns';
import deviceDetailsSagas from '../sagas/deviceDetails';
import suppressionsSagas from '../sagas/suppressions';
import statisticsSagas from '../sagas/statistics';
import logsSagas from '../sagas/logs';
import channelsSagas from '../sagas/channels';

export default [...campaignSagas, ...deviceDetailsSagas, ...logsSagas, ...statisticsSagas, ...suppressionsSagas, ...channelsSagas];
